/* eslint-disable import/prefer-default-export */

import { computed } from 'vue';
import { useStore } from 'vuex';
import {
    times, toFormat, lt, div,
} from '@/utils/number';

export function useLegal() {
    const store = useStore();
    const legalName = computed(() => store.state.settings.legalName);
    const usd2legal = computed(() => store.state.settings.usd2legal);
    const symbol2usdt = computed(() => store.state.settings.symbol2usdt);

    /**
     * USDT为单位的金额转换为以其他币种为单位的金额
     *
     * @param {string} currency 目标币种
     * @param {string} value 当前金额（以USDT为单位）
     * @return {string} 转换后的当前币种以currency为单位的金额
     */
    const usdtToQuote = (currency, value) => {
        if (!currency || !value) return '';
        if (!symbol2usdt.value[`${currency}USDT`]) return '';

        return div(value, symbol2usdt.value[`${currency}USDT`]);
    };

    /**
     * 通用方法：把货币数量转换成当前法币估值
     *
     * @param {Object} opts 法币转换参数
     * @param {string} opts.currency 当前数据的原始单位，如：USDT 、BTC 、ETH
     * @param {string} opts.value 数值
     * @return {string} 转换当前对应的法币后的数值结果
     */
    const toLegal = ({ currency, value } = {}) => {
        if (!currency || !legalName.value || !value) return '';
        if (!symbol2usdt.value[`${currency}USDT`]) return '';
        if (!usd2legal.value[legalName.value]) return '';
        // 这里直接取 *->USDT 的交易对，再乘 USD->法币 的汇率，默认 USDT->USD 为 1:1
        const usd = times(value, symbol2usdt.value[`${currency}USDT`]);
        return times(usd, usd2legal.value[legalName.value]);
    };

    /**
     * 法币格式化函数
     *
     * @param {Object} options 参数对象
     * @return {string} 格式化后的数值，例如：123,456.12、0.0000123
     */
    const toFormatLegal = (options) => {
        const legal = toLegal(options);
        let fixed = 2;

        // 小于0.1查找第一位有效的数字
        if (lt(legal, 0.1) && legal.search(/[1-9]/) !== -1) {
            fixed = legal.search(/[1-9]/) + 1; // 小数位保留至有效位数后两位
        }

        return legal ? toFormat(legal, fixed) : '';
    };

    return {
        usdtToQuote,
        toLegal,
        toFormatLegal,
        legalName,
    };
}
